import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import BasicDialog from '@zenbusiness/zui/BasicDialog';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import useAllPartnerOptOutUpdate from '#client/hooks/useAllPartnerOptOutUpdate';

const OptOutModal = ({ isOpen, onClose, refresh }) => {
  const [exception, setException] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    saveAllPartnerOptOut,
    loading,
    hasError: optOutError
  } = useAllPartnerOptOutUpdate();

  const handleSubmit = async (event) => {
    // Pass a custom onCompleted callback
    await saveAllPartnerOptOut(event, () => {
      setTimeout(() => {
        refresh();
      }, 2000);
    });

    onClose();
  };

  const handleClosePressed = useButtonPressedCallback({
    appSection: 'account',
    elementName: 'opt_out_modal_close',
    elementStyle: 'icon'
  });

  const handleClose = () => {
    onClose();
    handleClosePressed();
  };

  useEffect(() => {
    if (optOutError) {
      setException(true);
    }
  }, [optOutError]);

  if (exception) {
    throw exception;
  }

  return (
    <BasicDialog
      size="lg"
      title="Do not share or sell my personal information"
      primaryAction={{
        label: 'Submit',
        clickstreamProps: {
          appSection: 'account',
          elementName: 'opt_out_modal_submit'
        },
        loading,
        onClick: handleSubmit
      }}
      secondaryAction={{
        clickstreamProps: {
          appSection: 'account',
          elementName: 'opt_out_modal_cancel'
        },
        label: 'Cancel',
        onClick: onClose
      }}
      onClose={handleClose}
      open={isOpen}
      fullScreen={fullScreen}
    >
      <Stack gap={3}>
        <Stack>
          <Heading component="h2" size="md" wrap="wrap">California Consumer Privacy Act</Heading>
          <Text size="md" color="primary">
            The California Consumer Privacy Act of 2020 (CPRA) provides individual with a right to
            opt-out of the &quot;sharing&quot; or &quot;selling&quot; of personal information. The
            CPRA defines data sharing as any disclosure of personal information (renting, releasing,
            disclosing, disseminating, making available, transferring, or otherwise communicating
            orally, in writing, or by electronic or other means) to third parties.A &quot;sale&quot;
            is defined as the &quot;selling, renting, releasing, disclosing, disseminating, making
            available, transferring, or otherwise communicating orally, in writing,or by electronic
            or other means, a consumer&apos;s personal information by the business to another
            business or a third party for monetary or other valuable consideration.&quot;
          </Text>
        </Stack>
        <Stack>
          <Heading component="h2" size="md" wrap="wrap">
            How to opt-out of &quot;sharing&quot; or &quot;selling&quot; of personal information
          </Heading>
          <Text size="md" color="primary">
            You may submit your request to opt-out of potential &quot;sales&quot; of your personal
            information by entering your email address below. To protect your privacy, we take
            proactive measures to keep clear-text email addresses out of our system. Once you submit
            the form below, your email address will be automatically hashed (obfuscated) and sent to
            us. An automated message will then be emailed to you with a link to verify your request.
            Please click on that link within 30 days. Once you have verified your request, we will
            no longer “sell” any data we have associated with your hashed email address.
          </Text>
        </Stack>
      </Stack>
    </BasicDialog>
  );
};

OptOutModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired
};
export default OptOutModal;
